// 「数字」がクリックされた時
export const INPUT_NUMBER = "INPUT_NUMBER";

// 『+, -, ×, ÷』がクリックされた時
export const PLUS = "PLUS";
export const MINUS = "MINUS";
export const MULTIPLY = "MULTIPLY";
export const DIVIDE = "DIVIDE";

// 『=』がクリックされた時
export const EQUAL = "EQUAL";

// 『AC』がクリックされた時
export const CLEAR = "CLEAR";
